import Asientos from './pages/Asientos/Asientos';
import { useState, useEffect } from 'react';

function App() {
  // API key de servicio — sin vencimiento, no requiere login
  const [token] = useState(process.env.REACT_APP_SERVICE_KEY ?? '');
  const [zone, setZone]     = useState('');
  const [funcion, setFuncion] = useState(0);

  useEffect(() => {
    const postId = document.getElementById('react-admin-root')?.dataset?.postId;
    setFuncion(parseInt(postId ?? '0', 10));

    const handleZoneSelect = (e) => setZone(e.detail);
    window.addEventListener('zoneSelected', handleZoneSelect);
    return () => window.removeEventListener('zoneSelected', handleZoneSelect);
  }, []);

  if (!token) {
    console.error('[finaco-plugin] REACT_APP_SERVICE_KEY no está configurada en .env');
    return null;
  }

  return (
    <>
      {zone && (
        <div style={{ border: '1px solid #ccc', padding: 10 }}>
          <p>Zona Seleccionada: <strong>{zone}</strong></p>
          <div className="App">
            <Asientos token={token} zona={zone} funcion={funcion} />
          </div>
        </div>
      )}
    </>
  );
}

export default App;
